import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationFaceId = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationFaceId',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_25679_73196)",
    fillRule: "evenodd",
    d: "M12 30a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V15.5C5 9.701 9.701 5 15.5 5H30a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H15.5a3.5 3.5 0 0 0-3.5 3.5V30Zm28 14a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm31 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0ZM32.448 71.44A22.2 22.2 0 0 0 50 80.1a22.2 22.2 0 0 0 17.552-8.66c.674-.876.39-2.12-.544-2.711l-2.594-1.644c-.943-.596-2.182-.296-2.89.567a14.901 14.901 0 0 1-23.05 0c-.706-.863-1.945-1.163-2.888-.567L32.99 68.73c-.934.591-1.217 1.835-.543 2.711ZM30 95a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H15.5a3.5 3.5 0 0 1-3.5-3.5V70a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v14.5C5 90.299 9.701 95 15.5 95H30Zm54.5 0H70a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h14.5a3.5 3.5 0 0 0 3.5-3.5V70a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v14.5C95 90.299 90.299 95 84.5 95ZM93 32a2 2 0 0 0 2-2V15.5C95 9.701 90.299 5 84.5 5H70a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h14.5a3.5 3.5 0 0 1 3.5 3.5V30a2 2 0 0 0 2 2h3ZM43.5 64a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1 3.5 3.5 0 0 0 3.5-3.5V44c-.054-6.328-5.171-11.446-11.5-11.5a11.4 11.4 0 0 0-5.2 1.239c-.987.501-2.239.342-2.903-.544L25.6 30.8c-.662-.884-.488-2.148.462-2.712A18.501 18.501 0 0 1 54 44v9.5C54 59.3 49.3 64 43.5 64Zm27.201-30.262c.987.502 2.239.343 2.903-.543L75.4 30.8c.663-.884.488-2.148-.462-2.711A18.501 18.501 0 0 0 65.5 25.5a17.899 17.899 0 0 0-8.624 2.167c-.96.521-1.186 1.76-.577 2.667l1.672 2.486c.621.925 1.874 1.144 2.89.685A11.298 11.298 0 0 1 65.5 32.5a11.4 11.4 0 0 1 5.2 1.238Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_25679_73196",
    x1: 50.005,
    x2: 50.005,
    y1: 4.999,
    y2: 94.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#2AC2FE"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#4961FF"
  }))));
};
ColoredIllustrationFaceId.displayName = 'ColoredIllustrationFaceId';
export default withProvisionalOverrideFromContext(ColoredIllustrationFaceId);
//# sourceMappingURL=index.js.map